import {HeadingProps} from 'react-markdown/lib/ast-to-react';

import {Text} from '#component/base';

import {heading3} from '../Markdown.css';

export const Heading3 = ({children}: React.PropsWithChildren<HeadingProps>) => {
  return (
    <Text as="h3" variant="label" className={heading3}>
      {children}
    </Text>
  );
};
